import React, { useState,useEffect } from 'react';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "./BlogDetails.css";
import { useParams } from 'react-router-dom';
import API from "../../Utils/Api";
import loader from "../../assests/loader.gif";


const BlogDetails = () => {
  const [loading, setLoading] = useState(true);

  const [inputs,setInputs] = useState({id:'',mobile_thumb:'',desktop_header:'',title:'',subtitle:'',description:''});

  const { id } = useParams();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    document.title = `BlogDetails | Your Friend, My Friend`;
    document.getElementById('bodywrap').className = 'contact';

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", "Get in touch with the YFMF team. We’re here to help with event bookings, app support, sponsorships and media enquiries.");
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    let formData = new FormData(); 
        formData.append('blog_id', id);
        API.post('get_blog_detail',formData)
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                    setInputs({
                      id:response.data.data.id,
                      mobile_thumb:response.data.data.mobile_thumb,
                      desktop_header:response.data.data.desktop_header,
                      title:response.data.data.title,
                      subtitle:response.data.data.subtitle,
                      description:response.data.data.description
                    });
                    
                }                  
            }).catch(error => {
                setLoading(false); 
            });  

  }, [id]);

  return (
    <>
      <Header />

      <div className="blogdetails">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 p-0">

              <div className="article mb-5">
                <img
                  src={inputs.desktop_header}
                  alt=""
                  className="img-fluid w-100 d-none d-sm-block blogd-main"
                />
                <img
                  src={inputs.mobile_thumb}
                  alt="blog"
                  className="img-fluid w-100 d-block d-sm-none"
                />
              </div>

              <div className="p-4">

                <div className="white-box">
                  <h1>{inputs.title}</h1>
                  <p>{inputs.subtitle}</p>
                  
                </div>
                <div className="blog-description">
                  <div dangerouslySetInnerHTML={{ __html: inputs.description }} />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
      <Footer />
    </>
  );
};

export default BlogDetails;
